import React, {Component} from 'react'
import '../../../assets/sass/pages/talent-search.scss';
import MainToolbar from "./talent_search/MainToolbar";
import TalentSearchDataTable from "../../ui/data_tables/PlayerDataTable";
import rows from './PlayerRows';

class TalentSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            page: 0,
            pageSize: 0,
            totalRows: 0,
            filteredRows: 0,

            searchValue: null,
            regions: [],
            countries: [],
        };
    }

    /**
     * Renders the talent search screen.
     * @returns {React.ReactNode} The talent search screen.
     */
    render = () => {
        return (
            <div className="talent-search-wrapper">
                {this.renderToolbar()}
                {this.renderTable()}
            </div>
        );
    };

    /**
     * Renders the toolbar of talent search table.
     * @returns {React.ReactNode} The talent of search datatable toolbar.
     */
    renderToolbar = () => {
        const bookmarkCount = rows.filter(row => row.bookmarked).length;
        const selectedCount = rows.filter(row => row.selected).length;

        return (
            <MainToolbar
                bookmarkCount={bookmarkCount}
                selectedCount={selectedCount}
                // onMarkedListClear={this.handleMarkedListClear}
                onRegionsChange={this.handleRegionsChange}
                onSearchChange={this.handleSearchChange}
            />
        );
    };

    /**
     * Renders the talent of search datatable.
     * @returns {React.ReactNode} The talent of search datatable.
     */
    renderTable = () => {
        return (
            <TalentSearchDataTable page={this.props.unique}/>
        );
    };

    handleSearchChange = (value) => {
        this.setState({
            ...this.state,
            searchValue: value,
        });
    };

    handleRegionsChange = (regions) => {
        this.setState({
            ...this.state,
            regions: regions
        })
    }
}

export default TalentSearch;
